import React, {Component} from 'react' // eslint-disable-line no-unused-vars
import ReactDOM from 'react-dom'
import {withRouter} from 'react-router-dom'

const modalRoot = document.getElementById('modal')

class Modal extends Component {
  constructor(props) {
    super(props)
    this.el = document.createElement('div')
  }

  componentDidMount() {
    // The portal element is inserted in the DOM tree after
    // the Modal's children are mounted, meaning that children
    // will be mounted on a detached DOM node. If a child
    // component requires to be attached to the DOM tree
    // immediately when mounted, for example to measure a
    // DOM node, or uses 'autoFocus' in a descendant, add
    // state to Modal and only render the children when Modal
    // is inserted in the DOM tree.
    modalRoot.appendChild(this.el)
    document.body.style.height = '100vh'
    document.body.style.overflow = 'hidden'
  }

  componentWillUnmount() {
    document.body.style.height = 'auto'
    document.body.style.overflow = 'auto'
    modalRoot.removeChild(this.el)
  }

  /*componentDidUpdate(prevProps) {
    const isOpen = this.props.location.search.includes('modalopen=true')
    console.log('isOpen', isOpen)
    if(!isOpen) modalRoot.removeChild(this.el)
  }*/

  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.el,
    )
  }
}

export default withRouter(Modal)



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js